export enum DateFilterType {
    single = 'single',
    range = 'range'
}
